export default {
  session: {
    login: {
      doing: "Logger inn...",
      success: "Logget inn",
      error: "Kunne ikke logge inn",
    },
    authenticate: {
      doing: "Autentiserer...",
      success: "Autentisert",
      error: "Autentisering mislyktes",
    },
  },
  tracks: {
    artwork: {
      upload: {
        doing: "Laster opp albumkunst...",
        success: "Albumkunst lastet opp",
        error: "Albumkunst ble ikke lastes opp",
      },
      delete: {
        doing: "Sletter albumkunst...",
        success: "Albumkunst slettet",
        error: "Albumkunst ble ikke slettet",
      },
    },
    track: {
      create: {
        doing: "Oppretter låt...",
        success: "Låt opprettet",
        error: "Låten ble ikke opprettet",
      },
      delete: {
        doing: "Sletter låt...",
        success: "Låt slettet",
        error: "Låta ble ikke slettet",
      },
      update: {
        doing: "Oppdaterer låt...",
        success: "Låt oppdatert",
        error: "Låta ble ikke oppdatert",
      }
    },
    spotify: {
      getTrackInformation: {
        doing: "Henter låtinformasjon fra Spotify...",
        success: "Låtinformasjon hentet",
        error: "Låtinformasjon ble ikke hentet",
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/locales/no/global/io.js